/**
 * Converts milliseconds to a compact duration format.
 * Only shows non-zero parts: e.g., "1h 30m 45s", "30m 45s", "45s"
 * Returns "0s" for zero or invalid input.
 */
export const formatMillisecondsToDuration = (ms: number): string => {
  if (!Number.isFinite(ms) || ms <= 0) {
    return '0s';
  }

  const totalSeconds = Math.floor(ms / 1000);
  const hoursPart = Math.floor(totalSeconds / 3600);
  const minutesPart = Math.floor((totalSeconds % 3600) / 60);
  const secondsPart = totalSeconds % 60;

  const parts: string[] = [];
  if (hoursPart > 0) parts.push(`${hoursPart}h`);
  if (minutesPart > 0) parts.push(`${minutesPart}m`);
  if (secondsPart > 0) parts.push(`${secondsPart}s`);

  return parts.length > 0 ? parts.join(' ') : '0s';
};

/**
 * Converts seconds to a compact duration format.
 * Only shows non-zero parts: e.g., "1h 30m 45s", "30m 45s", "45s"
 */
export const formatSecondsToDuration = (seconds: number): string => {
  return formatMillisecondsToDuration(seconds * 1000);
};

/**
 * Converts minutes to a compact duration format.
 * Only shows non-zero parts: e.g., "1h 30m 45s", "30m 45s", "45s"
 */
export const formatMinutesToDuration = (minutes: number): string => {
  return formatMillisecondsToDuration(minutes * 60 * 1000);
};
